// extracted by mini-css-extract-plugin
module.exports = {"container":"TabList__container--1rAbd","center":"TabList__center--2DApt"};